import React from 'react'
import styled from 'styled-components'
import HeavyEquipment from '../../components/rentalPages/HeavyEquipment'
import Announcement from '../../components/Announcement'
import Navbar from '../../components/Navbar'
import Footer from '../../components/Footer'
import RentalAnnouncement from '../../components/RentalAnnouncement'
import { mobile } from '../../responsive'


const Container = styled.div`

`;
const Title = styled.h1`
    font-size: 40px;
    text-align: center;
    ${mobile({ paddingTop: "25px", paddingBottom: "10px" })}
`;

const HeavyEquipmentFinal = () => {
  return (
    <Container>
        <Navbar/>
        <Announcement/>
        <Title>Heavy Equipment:</Title>
        <RentalAnnouncement/>
        <HeavyEquipment/>
        <Footer/>
    </Container>
  )
}

export default HeavyEquipmentFinal